import { useListView } from '../../core/ListViewProvider'
import { GenerateAsoListGrouping } from './GenerateAsoListGrouping'
import { GenerateAsoListSearchComponent } from './GenerateAsoListSearchComponent'

export const GenerateAsoListHeader = () => {
  const { selected } = useListView()

  return (
    <div className='card-header border-0 pt-6'>
      <GenerateAsoListSearchComponent
        actions={selected.length > 0 ? <GenerateAsoListGrouping /> : undefined}
      />
    </div>
  )
}
